{
  "#VEHICLE": {
    "FORM": {
      "VEHICLE_NUMBER": "Fahrgestellnummer",
      "VEHICLE_NUMBER_INVALID": "Keine gültige Fahrgestellnummer (17 Zeichen, A-Z/0-9 ohne I, O, Q).",
      "VEHICLE_NAME": "Fahrzeugbezeichnung",
      "GENERAL": {
        "TITLE": "Allgemein",
        "LICENSE_PLATE": "A Kennzeichen",
        "LICENSE_PLATE_INVALID": "Bitte geben Sie Ihr Kennzeichen lt. Zulassungsschein bzw. Kennzeichentafel ein. Anstelle des Wappens verwenden Sie bitte einen Bindestrich (Beispiel: X-12345Y). Ihre Eingabe entspricht nicht den Vorgaben für ein gültiges Kennzeichen.",
        "USAGE": "A4 Verwendungsbestimmung",
        "FIRST_REGISTRATION": "B Erstmalige Zulassung am"
      },
      "CUSTOMER_INFORMATION": {
        "TITLE": "Kundeninformation",
        "CUSTOMER": "Kunde",
        "SALES_ORGANISATION": "Anlagefiliale",
        "ACTIVE": "Aktiv"
      },
      "CLASSIFICATION": {
        "TITLE": "Klassifizierung",
        "HANDOVER_DATE": "Übergabedatum",
        "INSPECTION_TYPE": "§57a-Pickerltyp",
        "ENGINE_NUMBER": "Motornummer",
        "MAIN_CLASS": "Hauptklasse",
        "SUB_CLASS": "Unterklasse",
        "YEAR_BUILD": "Baujahr"
      },
      "TYPE": {
        "TITLE": "Typ",
        "EURO_TAX_CODE": "A7 National Code",
        "VEHICLE_TYPE": "J Klasse / Fahrzeug",
        "BRAND": "D1 Marke",
        "TRADE_NAME": "D3 Handelsbezeichnung",
        "VARIANT": "D2 Type / Variante / Version",
        "STRUCTURE": "A8 Aufbau"
      },
      "WEIGHT": {
        "TITLE": "Gewicht",
        "SELF_WEIGHT": "G Eigengewicht",
        "TECH_TOTAL_WEIGHT": "F1 Techn. zul. Gesamtgewicht",
        "TOTAL_WEIGHT": "Höchstes zulässiges F2 Gesamtgewicht",
        "PAYLOAD": "Höchste zulässige A10 Nutzlast",
        "SADDLE_LOAD": "Höchste zulässige A12 Sattellast"
      },
      "AXLE_LOAD": {
        "TITLE": "Achslast",
        "AXLE_LOAD_1": "Höchstzulässige Achslast 1",
        "AXLE_LOAD_2": "Höchstzulässige Achslast 2",
        "AXLE_LOAD_3": "Höchstzulässige Achslast 3",
        "AXLE_LOAD_4": "Höchstzulässige Achslast 4",
        "TRAILER_LOAD_BRAKED": "O1 Anhängerlast gebr.",
        "TRAILER_LOAD_UNBRAKED": "O2 Anhängerlast ungebremst"
      },
      "MOTOR": {
        "TITLE": "Motor / Reifen",
        "MOTOR_TYPE": "P5 Motortype",
        "DRIVE_TYPE": "P3 Antriebsart",
        "MAX_SPEED": "T Höchstgeschw (in km/h)",
        "ENGINE_DISPLACEMENT": "P1 Hubraum (in cm)",
        "HP": "P2 Leistung (in kW)",
        "TIRE_DIMENSION": "A13 Reifendim"
      },
      "TOOL": {
        "TITLE": "Allgemein",
        "PRODUCT": "Artikel",
        "SERIAL_NUMBER": "Seriennummer",
        "PIN": "PIN",
        "DESCRIPTION": "Info",
        "READY_FOR_OPERATION": "Betriebsfertige Auslieferung",
        "TRADE_NAME": "Gerätebezeichnung"
      }
    }
  }
}
